// TODO: simplify when module namespaced
export const PRODUCT_TRANSITION_PROCESS_CLEAR_STATE = "clearProductTransitionProccess";

// TODO: simplify when module namespaced
export const PRODUCT_TRANSITION_PROCESS_CLEAR_ACTION = "clearProductTransitionProccessAction";

export const ProductTransitionProcessStoreActions = {
	CLEAR: `${PRODUCT_TRANSITION_PROCESS_CLEAR_ACTION}`
} as const;
